import { uiText } from "@/lib/i18n/uiText";
import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

declare global {
  interface Window {
    __statlignChatway?: number;
  }
}

function loadChatway() {
  if (typeof document === "undefined" || document.getElementById("chatway")) return;
  window.__statlignChatway = 1;
  const script = document.createElement("script");
  script.id = "chatway";
  script.async = true;
  script.src = "https://cdn.chatway.app/widget.js?id=i3KwuA8KuYnp";
  document.head.appendChild(script);
}

export function ChatButton() {
  const [loading, setLoading] = useState(false);

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className="h-11 w-11 shrink-0"
      aria-label={uiText("Open support chat")}
      title={uiText("Support chat")}
      disabled={loading}
      onClick={() => {
        setLoading(true);
        loadChatway();
        window.setTimeout(() => setLoading(false), 1500);
      }}
    >
      <MessageCircle className="h-5 w-5" aria-hidden="true" />
    </Button>
  );
}